export const desktopMenu = () => {
	// add minimized class to body when scrolled down
	const handleScroll = () => {
		document.body.classList.toggle('minimized', window.scrollY >= 200);
	};

	window.addEventListener('scroll', handleScroll);

	// on main-navigation items with children, add ada attributes & keyboard functionality
	const menuItems = Array.from(
		document.querySelectorAll('.main-navigation > ul > .menu-item-has-children, .main-navigation .languages'),
	);

	menuItems.forEach((item) => {
		// if this menu item's href="#", add role="button"
		const button = item.querySelector('a, button');
		const isAnchor = button && button.getAttribute('href') === '#';
		if (isAnchor) {
			button.setAttribute('role', 'button');
			// add aria-haspopup to item
			button.setAttribute('aria-haspopup', true);
		}

		// copy ID to the submenu
		const submenu = item.querySelector('ul');
		const id = item.getAttribute('id');
		const submenuId = `${id}-submenu`;
		submenu.setAttribute('id', submenuId);

		// set aria attributes
		button.setAttribute('aria-expanded', false);
		button.setAttribute('aria-controls', submenuId);

		// add blur event to submenu items
		submenu.querySelectorAll('a').forEach((link) => {
			link.addEventListener('click', () => {
				console.log('click link in submenu');
				item.classList.toggle('is-open');
				button.setAttribute('aria-expanded', item.classList.contains('is-open'));
			});
		});

		button.addEventListener('click', (e) => {
			if (isAnchor) e.preventDefault();

			// close other open submenus
			menuItems.forEach((otherItem) => {
				if (otherItem !== item) {
					otherItem.classList.remove('is-open');
					otherItem.querySelector('a').setAttribute('aria-expanded', false);
				}
			});

			item.classList.toggle('is-open');
			button.setAttribute('aria-expanded', item.classList.contains('is-open'));

			// focus first link in submenu
			const firstLink = submenu.querySelector('a');
			firstLink.focus();
		});
	});
};
